import { render, staticRenderFns } from "./ModalVerDetalleCrm.vue?vue&type=template&id=78b472e0&"
import script from "./ModalVerDetalleCrm.vue?vue&type=script&lang=ts&"
export * from "./ModalVerDetalleCrm.vue?vue&type=script&lang=ts&"
import style0 from "./ModalVerDetalleCrm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports